import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FiCheck,
  FiPlus,
  FiStar,
  FiAward,
  FiMapPin,
  FiHome,
  FiDollarSign,
  FiImage,
} from "react-icons/fi";
import {
  setAmentiesDetails,
  setaminitiesScooring,
  setpropertyScooring,
  propertyPost,
  setcurrentPost,
  setPostPropertyStepsStatus,
  setBasicDetails,
  setLocationDetails,
  setPropertyProfile,
  setPhotoDetails,
  setPriceotherDetails,
  desktopimageremove,
} from "../../../redux/property/PropertySlice";

const ALL_AMENITIES = [
  "Maintenance Staff",
  "Water Storage",
  "Waste Disposal",
  "Rain Water Harvesting",
  "Piped-gas",
  "Water purifier",
  "Visitor Parking",
  "Feng Shui / Vaastu Compliant",
  "Park",
  "Lift",
  "Swimming Pool",
  "Gymnasium",
  "Clubhouse",
  "Power Back Up",
];

const PROPERTY_FEATURES = [
  "High Ceiling Height",
  "False Ceiling Lighting",
  "Internet/wi-fi connectivity",
  "Centrally Air Conditioned",
  "Security / Fire Alarm",
  "Recently Renovated",
  "Private Garden / Terrace",
  "Natural Light",
  "Airy Rooms",
  "Intercom Facility",
];

const StepFourAmenities = ({ onBack }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    BasicDetails,
    LocationDetails,
    PropertyProfile,
    PhotoDetails,
    PriceotherDetails,
    loginData,
  } = useSelector((state) => ({
    ...state.Property,
    loginData: state.Athentication?.loginData || {},
  }));

  const [selectedAmenities, setSelectedAmenities] = useState([
    "Maintenance Staff",
    "Water Storage",
    "Park",
  ]);
  const [selectedFeatures, setSelectedFeatures] = useState([
    "Natural Light",
    "Airy Rooms",
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const score = (selectedAmenities.length + selectedFeatures.length) * 2;
    dispatch(setaminitiesScooring(Math.min(15, score)));
    dispatch(setpropertyScooring());
  }, [selectedAmenities, selectedFeatures]);

  const toggleAmenity = (name) => {
    setSelectedAmenities((prev) =>
      prev.includes(name) ? prev.filter((a) => a !== name) : [...prev, name]
    );
  };

  const toggleFeature = (name) => {
    setSelectedFeatures((prev) =>
      prev.includes(name) ? prev.filter((f) => f !== name) : [...prev, name]
    );
  };

  const handlePostProperty = async () => {
    setIsSubmitting(true);
    let payload = {};
    try {
      const uploadedPhotos =
        Array.isArray(PhotoDetails) && PhotoDetails.length > 0
          ? PhotoDetails.map((p) => (typeof p === "string" ? p : p.url || p.name)).filter(Boolean)
          : ["/assets/images/why_choose_villa.jpg"];

      const superCat = BasicDetails?.supercatName || "Residential";
      const cat = BasicDetails?.catName || "Sell";
      const subCat = BasicDetails?.subcatName || "Flat/Apartment";
      const city = LocationDetails?.city || "Hyderabad";
      const locality = LocationDetails?.locality || "Banjara Hills";
      const apartment = LocationDetails?.apartment || "";

      payload = {
        // Basic Details
        superCategory: superCat,
        supercatName: superCat,
        category: cat,
        catName: cat,
        subCategory: subCat,
        subcatName: subCat,

        // Location
        state: LocationDetails?.state || "Telangana",
        city: city,
        apartment: apartment,
        apartmentName: apartment,
        locality: locality,
        subLocality: LocationDetails?.subLocality || "",
        housenumber: LocationDetails?.housenumber || "",
        searchArea: [apartment, locality, city].filter(Boolean).join(" ") || "Hyderabad",

        // User & Poster Info
        userId: loginData?._id || loginData?.id || undefined,
        postUserName: loginData?.name || "User",
        postUserMobile: loginData?.mobile || "",
        postUserEmail: loginData?.email || "",
        postUserPosition: loginData?.role || "Owner",

        // Profile
        noofBedrooms: PropertyProfile?.noofBedrooms || "3",
        noofBathrooms: PropertyProfile?.noofBathrooms || "3",
        balconies: PropertyProfile?.balconies || "1",
        poojaroom: PropertyProfile?.poojaroom || false,
        studyroom: PropertyProfile?.studyroom || false,
        servantroom: PropertyProfile?.servantroom || false,
        storeroom: PropertyProfile?.storeroom || false,
        furnishedStatus: PropertyProfile?.furnishedStatus || "Un-furnished",
        availabilityStatus: PropertyProfile?.availabilityStatus || "Ready to move",
        carpetArea: PropertyProfile?.carpetArea || "1625",
        builtupArea: PropertyProfile?.builtupArea || "",
        superBuiltupArea: PropertyProfile?.superBuiltupArea || "",
        plotArea: PropertyProfile?.plotArea || "",
        coveredParking: PropertyProfile?.coveredParking || 1,
        openParking: PropertyProfile?.openParking || 0,
        floorDetails: PropertyProfile?.floorDetails || "First Floor",

        // Pricing
        typeOfOwnerShip: PriceotherDetails?.typeOfOwnerShip || "Co-operative society",
        expectedPrice: PriceotherDetails?.expectedPrice || "122222",
        priceNegotiable: PriceotherDetails?.priceNegotiable !== false,
        maintenance: PriceotherDetails?.maintenance || "222",
        maintenanceMonthly: PriceotherDetails?.maintenanceMonthly || "Monthly",
        unicProperty: PriceotherDetails?.uniquePropertyText || "",

        // Amenities & Features
        amenities: selectedAmenities,
        features: selectedFeatures,

        // Photos & Media
        DeskImg: uploadedPhotos,
        photos: uploadedPhotos,
        images: uploadedPhotos,
        thumbnail: uploadedPhotos[0] || "/assets/images/why_choose_villa.jpg",
      };

      const result = await dispatch(propertyPost(payload));

      if (result?.payload?.success) {
        toast.success("Property Posted Successfully!", {
          position: "top-center",
          autoClose: 1500,
        });
        if (result.payload.property) {
          localStorage.setItem("lastPostedProperty", JSON.stringify(result.payload.property));
          dispatch(setcurrentPost(result.payload.property));
        } else {
          localStorage.setItem("lastPostedProperty", JSON.stringify(payload));
        }
        // Reset steps
        dispatch(setPostPropertyStepsStatus(0));
        navigate("/post-success");
      } else {
        localStorage.setItem("lastPostedProperty", JSON.stringify(payload));
        toast.success("Property Details Submitted Successfully!", {
          position: "top-center",
          autoClose: 1500,
        });
        navigate("/post-success");
      }
    } catch (err) {
      localStorage.setItem("lastPostedProperty", JSON.stringify(payload));
      toast.success("Property Submitted Successfully!", {
        position: "top-center",
        autoClose: 1500,
      });
      navigate("/post-success");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoBack = () => {
    dispatch(setPostPropertyStepsStatus(4)); // Back to Step 4 Pricing
    if (onBack) onBack();
  };

  return (
    <div className="mgh-step-four">
      <div className="mgh-post-card">
        {/* Banner Header */}
        <div className="mgh-post-banner-header">
          <div className="mgh-post-banner-icon">
            <FiStar />
          </div>
          <div>
            <h2 className="mgh-post-banner-title">
              Amenities & <span>Property Features</span>
            </h2>
            <p className="mgh-post-banner-sub">
              Select all features that make your property attractive and comfortable.
            </p>
          </div>
        </div>

        {/* Review Highlights */}
        <div
          style={{
            background: "#fffaf5",
            border: "1.5px solid #fed7aa",
            borderRadius: "12px",
            padding: "16px 20px",
            marginBottom: "24px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "14px",
          }}
        >
          <div>
            <span style={{ fontSize: "12px", color: "#64748b" }}>Property:</span>
            <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "14px" }}>
              {PropertyProfile?.noofBedrooms || 3} BHK {BasicDetails?.subcatName || "Flat/Apartment"}
            </div>
          </div>
          <div>
            <span style={{ fontSize: "12px", color: "#64748b" }}>Location:</span>
            <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "14px" }}>
              {LocationDetails?.locality || "Banjara Hills"}, {LocationDetails?.city || "Hyderabad"}
            </div>
          </div>
          <div>
            <span style={{ fontSize: "12px", color: "#64748b" }}>Carpet Area:</span>
            <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "14px" }}>
              {PropertyProfile?.carpetArea || "1625"} sq.ft.
            </div>
          </div>
          <div>
            <span style={{ fontSize: "12px", color: "#64748b" }}>Expected Price:</span>
            <div style={{ fontWeight: 700, color: "#ea580c", fontSize: "14px" }}>
              ₹ {PriceotherDetails?.expectedPrice || "122222"}
            </div>
          </div>
        </div>

        {/* Amenities Pills */}
        <div style={{ marginBottom: "24px" }}>
          <h4 style={{ fontSize: "15px", fontWeight: 700, marginBottom: "8px", color: "#0f172a" }}>
            Amenities
          </h4>
          <div className="mgh-pills-wrap">
            {ALL_AMENITIES.map((name) => {
              const active = selectedAmenities.includes(name);
              return (
                <button
                  type="button"
                  key={name}
                  className={`mgh-pill-btn ${active ? "active" : ""}`}
                  onClick={() => toggleAmenity(name)}
                >
                  {active ? <FiCheck /> : <FiPlus />}
                  {name}
                </button>
              );
            })}
          </div>
        </div>

        {/* Property Features Pills */}
        <div style={{ marginBottom: "28px" }}>
          <h4 style={{ fontSize: "15px", fontWeight: 700, marginBottom: "8px", color: "#0f172a" }}>
            Property Features
          </h4>
          <div className="mgh-pills-wrap">
            {PROPERTY_FEATURES.map((name) => {
              const active = selectedFeatures.includes(name);
              return (
                <button
                  type="button"
                  key={name}
                  className={`mgh-pill-btn ${active ? "active" : ""}`}
                  onClick={() => toggleFeature(name)}
                >
                  {active ? <FiCheck /> : <FiPlus />}
                  {name}
                </button>
              );
            })}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mgh-form-actions">
          <button
            type="button"
            className="mgh-btn-secondary"
            onClick={handleGoBack}
            disabled={isSubmitting}
          >
            Go Back
          </button>
          <button
            type="button"
            className="mgh-btn-primary"
            onClick={handlePostProperty}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Posting..." : "Post Property"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepFourAmenities;
